import { GET, POST, PUT, DELETE } from "../../../../../module/services/fetch";
import { map } from "rxjs/operators";
import {
  INewReportRoles,
  IReportType,
  ISendToGenerate,
} from "../../module/constants";

export const getReports = () => {
  return GET("reports").pipe(map((res: any) => res));
};

export const deleteParameter = (data: IReportType) => {
  return DELETE("reports/parameters", data).pipe(map((res: any) => res));
};

export const getRoles = () => {
  return GET("authentication/admin/view-roles").pipe(map((res: any) => res));
};

export const getRepoRoles = (id: string) => {
  return GET(`reports/${id}/roles`).pipe(map((res: any) => res));
};

export const postReport = (data: INewReportRoles) => {
  return POST("reports", data).pipe(map((res: any) => res));
};

export const putReport = (data: IReportType, id: string) => {
  return PUT(`reports/${id}`, data).pipe(map((res: any) => res));
};

export const putRoles = (id: string, roles: string[]) => {
  return PUT(`reports/${id}/roles`, roles).pipe(map((res: any) => res));
};

export const deleteReport = (ids: string[]) => {
  return POST("reports/delete", ids).pipe(map((res: any) => res));
};

export const postGeneratePreview = (data: ISendToGenerate) => {
  return POST("reports/generatePreview", data).pipe(map((res: any) => res));
};
